import styled from 'styled-components'

export const Link = styled.a`
  line-height: 0;

  &:hover,
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
  }
`
